import type { ForceChangeContext } from '@/context/store/slices/authSlice';

const FORCE_CHANGE_STORAGE_KEY = 'wa.auth.forceChange';

export function saveForceChangeContext(context: ForceChangeContext): void {
  try {
    sessionStorage.setItem(FORCE_CHANGE_STORAGE_KEY, JSON.stringify(context));
  } catch {
    // sessionStorage may be unavailable in some environments.
  }
}

export function readForceChangeContext(): ForceChangeContext | null {
  try {
    const raw = sessionStorage.getItem(FORCE_CHANGE_STORAGE_KEY);
    if (!raw) return null;

    const parsed: unknown = JSON.parse(raw);
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'email' in parsed &&
      'session' in parsed &&
      typeof parsed.email === 'string' &&
      typeof parsed.session === 'string' &&
      parsed.email.length > 0 &&
      parsed.session.length > 0
    ) {
      return {
        email: parsed.email,
        session: parsed.session,
      };
    }

    return null;
  } catch {
    return null;
  }
}

export function clearForceChangeContext(): void {
  try {
    sessionStorage.removeItem(FORCE_CHANGE_STORAGE_KEY);
  } catch {
    // ignore
  }
}
